import React from 'react'
import {
  Avatar,
  Container,
  Divider,
  Grid,
  Paper,
  Typography,
  useTheme
} from '@material-ui/core'
import { Sapphire } from 'src/util/images'

const ListIcon: React.VFC = () => (
  <Avatar
    variant="square"
    src={Sapphire}
    style={{ width: 24, height: 24, backgroundColor: 'transparent' }}
  />
)

type ChangeLogPaperProps = {
  text: string
  date: string
}
const ChangeLogPaper: React.VFC<ChangeLogPaperProps> = ({ text, date }) => {
  const theme = useTheme()
  return (
    <Paper
      elevation={0}
      style={{
        backgroundColor: 'transparent',
        color: theme.palette.text.secondary,
        padding: theme.spacing(1)
      }}
    >
      <Grid container spacing={2}>
        <Grid
          item
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <ListIcon />
        </Grid>
        <Grid item>
          <Typography variant="caption">{date}</Typography>
          <Typography variant="body1">{text}</Typography>
        </Grid>
      </Grid>
    </Paper>
  )
}

const logs = [
  {
    text: <ChangeLogPaper text="ネタ画像ページ追加" date="2021/08/26" />
  },
  {
    text: (
      <ChangeLogPaper
        text="スプレッドシート読み込みエラー修正"
        date="2021/08/26"
      />
    )
  },
  {
    text: <ChangeLogPaper text="更新履歴ページ追加" date="2021/07/06" />
  },
  {
    text: <ChangeLogPaper text="ネタgifページ追加" date="2021/07/05" />
  },
  {
    text: <ChangeLogPaper text="スレ投下" date="2021/07/05" />
  },
  {
    text: (
      <ChangeLogPaper text="キャラ毎モーションページ作成" date="2021/07/05" />
    )
  },
  {
    text: <ChangeLogPaper text="各種モーションページ作成" date="2021/07/04" />
  },
  {
    text: <ChangeLogPaper text="作成開始" date="2021/07/03" />
  }
]
const ChangeLog: React.VFC = () => {
  return (
    <Container style={{ marginTop: 20 }}>
      <Typography variant="h4">更新履歴</Typography>
      <Divider style={{ marginBottom: 20 }} />
      <ul style={{ listStyle: 'none' }}>
        {logs.map((e, i) => (
          <li key={i}>{e.text}</li>
        ))}
      </ul>
    </Container>
  )
}

export default ChangeLog
